const form = () => {

    const forms = document.querySelectorAll('.form');
    [...forms].map(form => {


        const files = form.querySelectorAll('.form-widget--file-upload input[type=file]');
        [...files].map(inputElement => {
            //console.log(inputElement);
            const dropZoneElement = inputElement.closest(".form-widget--file-upload");
            const intTxt = dropZoneElement.innerHTML;

            dropZoneElement.addEventListener("click", (e) => {
                inputElement.click();
            });

            inputElement.addEventListener("change", (e) => {

                if (inputElement.files.length) {
                    updateThumbnail(dropZoneElement, inputElement.files[0]);
                }
            });

            dropZoneElement.addEventListener("dragover", (e) => {
                e.preventDefault();
                dropZoneElement.classList.add("drop-zone--over");
            });

            ["dragleave", "dragend"].forEach((type) => {
                dropZoneElement.addEventListener(type, (e) => {
                    dropZoneElement.classList.remove("drop-zone--over");
                });
            });

            dropZoneElement.addEventListener("drop", (e) => {
                e.preventDefault();

                if (e.dataTransfer.files.length) {
                    inputElement.files = e.dataTransfer.files;
                    updateThumbnail(dropZoneElement, e.dataTransfer.files[0]);
                }

                dropZoneElement.classList.remove("drop-zone--over");
            });

            /**
             * Updates the thumbnail on a drop zone element.
             *
             * @param {HTMLElement} dropZoneElement
             * @param {File} file
             */
            function updateThumbnail(dropZoneElement, file) {
                let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");

                // First time - remove the prompt
                if (dropZoneElement.querySelector(".drop-zone__prompt")) {
                    dropZoneElement.querySelector(".drop-zone__prompt").remove();
                }

                // First time - there is no thumbnail element, so lets create it
                if (!thumbnailElement) {
                    thumbnailElement = document.createElement("div");
                    thumbnailElement.classList.add("drop-zone__thumb");
                    const thumbnailRemove = document.createElement("a");
                    thumbnailRemove.classList.add("drop-zone__remove");
                    thumbnailElement.appendChild(thumbnailRemove);

                    thumbnailRemove.addEventListener('click', (e)=>{
                        e.stopPropagation();
                        e.preventDefault();
                        //console.log('xx', file);
                        clearInputFile(dropZoneElement);
                        dropZoneElement.innerHTML = intTxt;
                    });

                    dropZoneElement.appendChild(thumbnailElement);
                }


                thumbnailElement.dataset.label = file.name;

                // Show thumbnail for image files
                if (file.type.startsWith("image/")) {
                    const reader = new FileReader();

                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        thumbnailElement.style.backgroundImage = `url('${reader.result}')`;
                    };
                } else {
                    thumbnailElement.style.backgroundImage = null;
                }
            }


        });

    })

};

function clearInputFile(dropZoneElement){
    const f = dropZoneElement.querySelector('input[type=file]');
    if(f && f.value){
        try{
            f.value = ''; //for IE11, latest Chrome/Firefox/Opera...
        }catch(err){ }
        if(f.value){ //for IE5 ~ IE10
            var form = document.createElement('form'),
                parentNode = f.parentNode, ref = f.nextSibling;
            form.appendChild(f);
            form.reset();
            parentNode.insertBefore(f,ref);
        }
        f.dispatchEvent(new Event('change'));
    }
}

export default form;